module.exports = __webpack_public_path__ + "assets/img/netted-lines.svg";